import { CircleCheck, Clock, TriangleAlert } from 'lucide-react';
import { cn } from '@/shared/lib/utils';
import type { GroupVisualStatus } from './jobsModel';

interface JobStatusIconProps {
  state: GroupVisualStatus;
  /** Velikost glyfu v px (dle designu 14–16 dle kontextu). */
  size?: number;
  className?: string;
}

/**
 * Stavová ikona uzlu/jobu dle designu: hodiny (ve frontě / čeká), spinner (běží),
 * fajfka (dokončeno), trojúhelník (chyba). „waiting" sdílí glyf s „queued" (roll-up skupiny,
 * kde už něco doběhlo, ale nic neběží).
 */
export function JobStatusIcon({ state, size = 15, className }: JobStatusIconProps) {
  if (state === 'running') {
    const ringSize = size - 1;
    return (
      <span
        className={cn(
          'border-phx-info-tint border-t-phx-info inline-block animate-spin rounded-full border-2 [animation-duration:.7s]',
          className
        )}
        style={{ width: ringSize, height: ringSize }}
        aria-hidden
      />
    );
  }
  if (state === 'done') {
    return (
      <CircleCheck size={size} className={cn('text-phx-success shrink-0', className)} aria-hidden />
    );
  }
  if (state === 'error') {
    return (
      <TriangleAlert
        size={size}
        className={cn('text-phx-danger shrink-0', className)}
        aria-hidden
      />
    );
  }
  return (
    <Clock size={size - 1} className={cn('text-phx-text-faint shrink-0', className)} aria-hidden />
  );
}
